/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Faq_1_QInputs */

const en_nfp_faq_1_q = /** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Shoot Share Connect free for non-profits?`)
};

const es_nfp_faq_1_q = /** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Shoot Share Connect es gratuito para ONGs?`)
};

const fr_nfp_faq_1_q = /** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-ce que Shoot Share Connect est gratuit pour les associations ?`)
};

const de_nfp_faq_1_q = /** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Shoot Share Connect für NGOs kostenlos?`)
};

const id_nfp_faq_1_q = /** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Shoot Share Connect gratis untuk non-profit?`)
};

/** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */
const ja_nfp_faq_1_q = en_nfp_faq_1_q;

/** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */
const zh_nfp_faq_1_q = en_nfp_faq_1_q;

/** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */
const ar_nfp_faq_1_q = en_nfp_faq_1_q;

/** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */
const it_nfp_faq_1_q = en_nfp_faq_1_q;

/** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */
const ru_nfp_faq_1_q = en_nfp_faq_1_q;

/** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */
const pt_nfp_faq_1_q = en_nfp_faq_1_q;

/** @type {(inputs: Nfp_Faq_1_QInputs) => LocalizedString} */
const ko_nfp_faq_1_q = en_nfp_faq_1_q;

/**
* | output |
* | --- |
* | "Is Shoot Share Connect free for non-profits?" |
*
* @param {Nfp_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_faq_1_q = /** @type {((inputs?: Nfp_Faq_1_QInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Faq_1_QInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_faq_1_q(inputs)
	if (locale === "es") return es_nfp_faq_1_q(inputs)
	if (locale === "fr") return fr_nfp_faq_1_q(inputs)
	if (locale === "de") return de_nfp_faq_1_q(inputs)
	if (locale === "ja") return ja_nfp_faq_1_q(inputs)
	if (locale === "zh") return zh_nfp_faq_1_q(inputs)
	if (locale === "ar") return ar_nfp_faq_1_q(inputs)
	if (locale === "id") return id_nfp_faq_1_q(inputs)
	if (locale === "it") return it_nfp_faq_1_q(inputs)
	if (locale === "ru") return ru_nfp_faq_1_q(inputs)
	if (locale === "pt") return pt_nfp_faq_1_q(inputs)
	return ko_nfp_faq_1_q(inputs)
});